import { useEffect, useRef } from "react";
import * as journifyTrackingCarEvents from "../services/trackingCarEvents";

const toNumber = (v, def = 0) => {
  const n = Number(v);
  return Number.isFinite(n) ? n : def;
};

const toString = (v, def = "") => (v === undefined || v === null ? def : String(v));


export default  function useTrackBeginCheckout({
  car,
  currency = "SAR",
  creativeSlot, // اختياري لو تبي تربطه بمكان الظهور
}) {
  const firedRef = useRef("");

  useEffect(() => {
    if (!car) return;

    // منع تكرار نفس التتبع (خصوصاً في React StrictMode)

    const key = `${car?.ProductTarget || car?.ProductID || ""}`;
    if (firedRef.current === key) return;
    firedRef.current = key;

    const item = {
      // أهم شي: ID + Name
      item_id: toString(car?.ProductID ?? car?.ProductTarget, ""),
      item_name: toString(car?.DescriptionEn ?? car["Type English"], ""),

      affiliation: "value",
      coupon: "value",
      discount: 0,
      index: 0,

      // Brand / Categories
      item_brand: toString(car["Brand English"], "value"),
      item_category: toString(car["Group English"], "value"),       // مثل: RAIZE / Corolla / Camry
      item_category2: toString(car?.Model, "value"),       // مثل: 2026
      item_category3: toString(car?.category, "value"),   // مثل: سيدان / SUV
      item_category4: toString(car?.carGroupID, "value"), // مثل: GR30
      item_category5: toString(car?.type, "value"),       // مثل: TN1386

      // variant ممكن تستخدم modelTypes أو type
      item_variant: toString(car?.ColorDescriptionEn, "value"),

      location_id: toString(creativeSlot, "value"),

      price: toNumber(car?.NetSalePrice, 0),
      quantity: 1,
    };
    journifyTrackingCarEvents.trackBeginCheckout(item, currency);

  }, [car, currency, creativeSlot]);
}

